export default __webpack_public_path__ + "static/media/11.fc27a193.PNG";